import React from 'react';
import { Link } from 'react-router-dom';
import { Avatar, Box, Paper, Typography } from '@mui/material';
import medicaidId from '../../img/medicadeid.png';
import arrow from '../../img/arrow.png';

interface ApplicationCardProps {
  title: string;
  description: string;
  url: string | null;
  isExternal?: boolean;
  disabled?: boolean;
}

const ApplicationCard: React.FC<ApplicationCardProps> = ({
  title,
  description,
  url,
  isExternal = false,
  disabled = false
}) => {
  const CardContent = () => (
    <Paper
      elevation={0}
      sx={{
        border: 7,
        borderColor: '#aebbd6',
        borderRadius: '26px',
        position: 'relative',
        boxShadow: 'none',
        p: 3,
        minHeight: 200,
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        cursor: 'pointer'
      }}
    >
      <Typography component="div" sx={{ fontWeight: 'bold', textAlign: 'left' }}>
        {title}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
        <Avatar alt={title} sx={{ width: 60, height: 60, flex: '0 0 auto' }} src={medicaidId} />
        <Typography
          component="div"
          sx={{ fontSize: 10, letterSpacing: 0, lineHeight: 1.4, flex: 1, whiteSpace: 'normal', wordBreak: 'break-word' }}
        >
          {description}
        </Typography>
      </Box>
      <Avatar alt="Arrow" src={arrow} sx={{ width: 30, height: 25, position: 'absolute', right: 24, bottom: 24 }} />
    </Paper>
  );

  return (
    <div className="flex-grow">
      {disabled || !url ? (
        <CardContent />
      ) : isExternal ? (
        <a
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          style={{ textDecoration: 'none', color: 'inherit' }}
        >
          <CardContent />
        </a>
      ) : (
        <Link style={{ textDecoration: 'none' }} to={url}>
          <CardContent />
        </Link>
      )}
    </div>
  );
};

export default ApplicationCard;
